import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "d-flex flex-column" }
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = {
  key: 0,
  class: "caption text-grey-700 text-nowrap ms-2 d-flex align-items-center"
}
const _hoisted_4 = {
  key: 0,
  class: "caption-strong mt-2 d-flex align-items-center"
}
const _hoisted_5 = {
  key: 0,
  class: "mt-2 subcaption d-flex align-items-center"
}
const _hoisted_6 = { class: "d-flex align-items-center gap-2" }
const _hoisted_7 = { class: "title-3" }

import { computed, ComputedRef, ref, Ref } from "vue"
import type { ComponentPublicInstance } from "vue"

// Utils
import { isScreenMD } from "@/vue/planning/utils/breakpoints"

// Components
import FixedPaymentConditionPill from "./FixedPaymentConditionPill.vue"
import PlaceholderBox from "@/vue/planning/components/common/placeholderBox.vue"
import PackageDetailsTooltip from "./PackageDetailsTooltip.vue"
import DynamicPopup from "@/vue/common/DynamicPopup.vue"
import PaymentConditionPopup from "./PaymentConditionPopup.vue"
import TermsAndConditions from "./TermsAndConditions.vue"



// Props
interface Props {
	displayTitle: boolean
	content: { [key: string]: string }
	isPVFlex?: boolean
	prestId?: string
	isDisplayPlaceholders?: boolean
	cancellationDate?: string
	isCompactDisplay?: boolean
}

type DynamicPopupInstance = ComponentPublicInstance<typeof DynamicPopup>


export default /*@__PURE__*/_defineComponent({
  __name: 'FixedPaymentCondition',
  props: {
    displayTitle: { type: Boolean },
    content: {},
    isPVFlex: { type: Boolean },
    prestId: {},
    isDisplayPlaceholders: { type: Boolean },
    cancellationDate: {},
    isCompactDisplay: { type: Boolean }
  },
  setup(__props: any) {

const props = __props

// Refs
const popupRef: Ref<DynamicPopupInstance | null> = ref(null)

// Computed
const content: ComputedRef<{ [key: string]: string }> = computed(() => {
	return props.content
})

// Methods
const handleOpenPopup = (): void => {
	// Only open the popup if the device is mobile
	if (isScreenMD.value) return

	if (popupRef.value) {
		popupRef.value.openPopup()
	}
}

const handleClosePopUp = () => {
	if (popupRef.value) {
		popupRef.value.closePopup()
	}
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(FixedPaymentConditionPill, {
          content: props.content
        }, null, 8, ["content"]),
        (props.prestId)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
              (props.isDisplayPlaceholders)
                ? (_openBlock(), _createBlock(PlaceholderBox, {
                    key: 0,
                    height: '25px',
                    width: '100px'
                  }))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" ID: " + _toDisplayString(props.prestId), 1)
                  ], 64))
            ]))
          : _createCommentVNode("", true)
      ]),
      (props.displayTitle && !_ctx.isCompactDisplay)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(content.value.fixe_title), 1))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.isCompactDisplay)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(PackageDetailsTooltip, { onClick: handleOpenPopup }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createElementVNode("span", null, _toDisplayString(content.value.fixe_picto_i_terms_conditions_1), 1),
                _cache[0] || (_cache[0] = _createTextVNode()),
                _createVNode(TermsAndConditions)
              ])
            ]),
            _: 1
          }),
          _createElementVNode("div", null, _toDisplayString(content.value.fixe_line_1), 1)
        ]))
      : _createCommentVNode("", true),
    _createVNode(DynamicPopup, {
      ref_key: "popupRef",
      ref: popupRef,
      "overlay-color": 'rgba(13, 20, 27, 0.95)',
      "overlay-max-opacity": 1
    }, {
      default: _withCtx(() => [
        _createVNode(PaymentConditionPopup, { onClose: handleClosePopUp }, {
          title: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(FixedPaymentConditionPill, {
                content: props.content,
                height: 30
              }, null, 8, ["content"]),
              _createElementVNode("div", _hoisted_7, _toDisplayString(content.value.fixe_title), 1)
            ])
          ]),
          content: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(content.value.fixe_picto_i_terms_conditions_1), 1),
            _cache[1] || (_cache[1] = _createTextVNode()),
            _createVNode(TermsAndConditions)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 512)
  ]))
}
}

})